import { Avatar, Layout, Menu, Segmented, Typography } from "antd";
import { DesktopOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";
import { sidebarItems } from "../../data/admin";
import { getInitials } from "@/utils";

const { Text, Title } = Typography;
const { Sider } = Layout;

const employee = {
  name: "Amina Njoroge",
  role: "Platform Operations Lead",
  email: "amina@serid.app",
};

export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Sider width={300} theme="light">
      <div className="flex h-full flex-col justify-between">

        <div className="flex-1 overflow-y-auto px-3">
          <div className="border-b border-black/8 px-5 py-3 dark:border-white/8">
            <Text className="block text-[11px]! uppercase tracking-[0.18em] text-black/45 dark:text-white/45">
              SERID Internal
            </Text>
            <Title level={5} className="mb-0! mt-1!">
              Admin Console
            </Title>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={sidebarItems}
            onClick={({ key }) => navigate(String(key))}
          />
        </div>

        <div className="border-t border-black/8 px-4 py-4 dark:border-white/8">
          <div className="rounded-md border border-black/8 bg-black/10 p-4 dark:border-white/8 dark:bg-white/3">
            <Text className="mb-2 block text-[11px]! uppercase tracking-[0.18em] text-black/45 dark:text-white/45">
              Appearance
            </Text>
            <Segmented
              block
              options={[
                { value: "light", icon: <SunOutlined /> },
                { value: "system", icon: <DesktopOutlined /> },
                { value: "dark", icon: <MoonOutlined /> },
              ]}
              value={localStorage.getItem("theme") ?? "system"}
              onChange={(value) => {
                localStorage.setItem("theme", String(value));
                window.dispatchEvent(new Event("serid-theme-change"));
              }}
            />
          </div>

          <div className="mt-4 flex items-center gap-3 rounded-md border border-black/8 bg-black/10 p-4 dark:border-white/8 dark:bg-white/3">
            <Avatar size={44}>{getInitials(employee.name)}</Avatar>
            <div className="min-w-0">
              <Text strong className="block truncate">{employee.name}</Text>
              <Text type="secondary" className="block truncate">{employee.role}</Text>
              <Text type="secondary" className="block truncate text-xs">{employee.email}</Text>
            </div>
          </div>
        </div>
      </div>
    </Sider>
  );
}
